module.exports = __webpack_public_path__ + "img/title.6dbf5ce2.png";